import styled from 'styled-components';
import { UncontrolledPopover } from 'reactstrap';

import { colors, fonts, device } from 'shared/defaultTheme';

export const ClientsWrapper = styled.div`
  display: flex;
  .backgroundbox-wrapper {
    @media ${device.sm} {
      flex: 0 0 87%;
      width: 97%;
      margin-left: 5px;
      .table {
        overflow-x: auto;
        display: block;
        max-width: fit-content;
        white-space: nowrap;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }

      .action-header-mobile {
        flex-direction: column-reverse;
        .w-container-search-mobile {
          width: 100% !important;
          margin-top: 10px;
        }
      }
    }
    @media ${device.md} {
      flex: 0 0 87%;
      width: 97%;
      margin-left: 15px;
      .table {
        overflow-x: auto;
        display: block;
        max-width: fit-content;
        white-space: nowrap;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }
    }
    @media ${device.lg} {
      flex: 0 0 87%;
      width: 97%;
      margin-left: 15px;
      .table {
        overflow-x: auto;
        display: block;
        max-width: fit-content;
        white-space: nowrap;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }
    }
    @media ${device.xl} {
      flex: 0 0 87%;
      width: 100%;
      margin-left: 0;
      .table {
        overflow-x: auto;
        display: inline-table;
        max-width: initial;
        white-space: nowrap;
      }
      .w-search-clients {
        width: 100%;
      }
      .btn-action-clients {
        height: 41px;
        align-items: center;
      }
    }
  }
  .table-clients {
    height: 660px;
  }
  .action-row-client {
    cursor: pointer;
    &:hover {
      background-color: ${colors.lightGray};
    }
  }
`;

export const CustomCollapseBody = styled.div`
  border-radius: 4px;
  background-color: ${colors.white};
  box-shadow: 0 0 4px 0 ${colors.lightSilverTwo};
  height: auto;
`;

export const OptionMenu = styled.div`
  width: 100%;
  cursor: pointer;
  height: auto;
  padding-right: 5px;
  padding-top: 4px;
  padding-left: 14px;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

export const FilterOptionMenu = styled.div`
  width: 100%;
  cursor: pointer;
  height: auto;
  padding-right: 5px;
  padding-top: 4px;
  padding-left: 14px;
  .custom-field-container {
    display: flex;
    margin-top: 10px;
    span {
      color: ${colors.suvaGrey};
      font-family: ${fonts.roboto};
      font-size: 13px;
      letter-spacing: 0;
      line-height: 18px;
    }
  }
`;

export const TableHeader = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: flex-start;
`;

export const TableHeaderText = styled.span`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: uppercase;
`;

export const TableBodyText = styled.div`
  white-space: nowrap;
  width: 150px;
  p {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .status-wrapper {
    font-family: ${fonts.default};
    font-weight: 900;
    font-size: 13px;
    line-height: 15px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 82px;
    text-transform: capitalize;
  }
  .classificationWrapper {
    display: flex;
    justify-content: start;
    button {
      padding: 0;
      background-color: #aaaeb0;
      border-radius: 10px;
      height: 20px;
      width: 35px;
      color: #fff;
      font-size: 13px;
    }
  }
`;

export const Popover = styled(UncontrolledPopover)`
  .popover {
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    min-width: 80px;
    .popover-body {
      padding: 0;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
`;

export const StatusWrapper = styled.div`
  align-items: center;
  background-color: ${({ color }) => color};
  border-radius: 2px;
  color: ${colors.white};
  display: flex;
  font-family: MTTMilano;
  font-size: 13px;
  font-weight: 900;
  height: 20px;
  justify-content: center;
  letter-spacing: 0;
  line-height: 15px;
  text-align: center;
  width: 82px;
`;

export const GroupInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 8px;
  .required-mark {
    color: ${colors.error};
  }
`;
